<template>
  <div>
    <template v-if="!data.length > 0">
      <p>Brak danych w wybranym okresie</p>
    </template>
    <template v-else>
      <v-expansion-panels v-model="panel" multiple>
        <v-expansion-panel v-for="(film, i) in data" :key="i">
          <v-expansion-panel-header>
            Tytuł filmu: {{ film.name }}
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-data-table
              dense
              :headers="headers"
              :items="film.users"
              item-key="name"
              calculate-widths
            >
              <template v-slot:[`item.progress`]="{ item }">
                <v-progress-linear
                  color="primary"
                  height="16"
                  :value="item.progress"
                  striped
                >
                  <template v-slot="{ value }">
                    <strong>{{ getScore(value) }}%</strong>
                  </template>
                </v-progress-linear>
              </template>
            </v-data-table>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </template>
  </div>
</template>
<script>
export default {
  props: {
    data: Array[Object]
  },
  data() {
    return {
      panel: [0],
      headers: [
        {
          text: "Lekarz",
          value: "name",
          width: "50%"
        },
        {
          text: "Postęp",
          value: "progress",
          align: "center",
          width: "50%"
        }
      ]
    };
  },
  methods: {
    getScore(val) {
      return val.toFixed(2);
    }
  }
};
</script>
